(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.contact-form__form').forEach(function (form) {
    var fields = [
      { id: 'ContactForm-name', message: 'Please enter your name.' },
      { id: 'ContactForm-email', message: 'Please enter a valid email address.' },
      { id: 'ContactForm-body', message: 'Please enter your message.' },
    ];

    function validateField(input, errorEl, message) {
      var valid = true;
      if (input.required && !input.value.trim()) {
        errorEl.textContent = message;
        input.classList.add('contact-form__input--invalid');
        input.setAttribute('aria-invalid', 'true');
        valid = false;
      } else if (input.type === 'email' && input.value.trim()) {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(input.value.trim())) {
          errorEl.textContent = message;
          input.classList.add('contact-form__input--invalid');
          input.setAttribute('aria-invalid', 'true');
          valid = false;
        }
      }
      if (valid) {
        errorEl.textContent = '';
        input.classList.remove('contact-form__input--invalid');
        input.removeAttribute('aria-invalid');
      }
      return valid;
    }

    // Clear error on input
    fields.forEach(function (field) {
      var input = form.querySelector('#' + field.id);
      var errorEl = form.querySelector('#' + field.id + '-error');
      if (!input || !errorEl) return;
      input.addEventListener('input', function () {
        validateField(input, errorEl, field.message);
      });
      input.addEventListener('blur', function () {
        validateField(input, errorEl, field.message);
      });
    });

    // Validate on submit
    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      var allValid = true;
      fields.forEach(function (field) {
        var input = form.querySelector('#' + field.id);
        var errorEl = form.querySelector('#' + field.id + '-error');
        if (!input || !errorEl) return;
        var valid = validateField(input, errorEl, field.message);
        if (!valid && !firstInvalid) firstInvalid = input;
        if (!valid) allValid = false;
      });
      if (!allValid) {
        e.preventDefault();
        if (firstInvalid) firstInvalid.focus();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
